import React from 'react'
import { withRouter } from 'react-router-dom'
import { firebase } from '../firebase'
import { PATH_NAMES } from '../constants'

const withAuthorization = (authCondition) => (Component, componentProps) => {
	const {
		isAuthorizedRedirect,
		authorizationRequired,
	} = componentProps

	class WithAuthorization extends React.Component {
		constructor(props) {
			super(props)

			this.state = {
				render: null,
			}
		}

		componentDidMount() {
			firebase.auth.onAuthStateChanged((authUser) => {
				// redirect based on authorization requirement and condition
				if (authorizationRequired && !authCondition(authUser)) {
					// redirect to login
					this.props.history.push(PATH_NAMES.LOGIN)
				} else if (isAuthorizedRedirect && authCondition(authUser)) {
					// redirect to Browse, when you're logged in but request Home
					this.props.history.push(PATH_NAMES.BROWSE)
				}

				// if no need to redirect
				// let display the content of the route
				this.setState({
					render: <Component {...componentProps} />,
				})
			})
		}

		// will return null if user not logged in
		// feels like its doing double duty
		render() {
			const Render = this.state.render

			return Render
		}
	}

	return withRouter(WithAuthorization)
}

export default withAuthorization


// WEBPACK FOOTER //
// ./src/common/components/with-authorization.js